import { render, staticRenderFns } from "./EventCardSkeleton.vue?vue&type=template&id=751c5308&scoped=true"
import script from "./EventCardSkeleton.vue?vue&type=script&lang=js"
export * from "./EventCardSkeleton.vue?vue&type=script&lang=js"
import style0 from "./EventCardSkeleton.vue?vue&type=style&index=0&id=751c5308&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "751c5308",
  null
  
)

export default component.exports